import styles from './WhatDesignSystem.module.scss'
import { useEffect, useRef } from 'react'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollToPlugin'
gsap.registerPlugin(ScrollTrigger)

const WhatDesignSystem = () => {
  const slide = useRef<HTMLDivElement>()
  const section = useRef<HTMLElement>()
  useEffect(() => {
    if (window.innerWidth > 1024) {
      gsap.to(slide.current, {
        width: 0,
        duration: 0.5,
        scrollTrigger: {
          trigger: section.current,
          start: 'top-=350 top+=200',
        },
      })
    } else {
      gsap.to(slide.current, {
        width: 0,
        duration: 0.5,
        scrollTrigger: {
          trigger: section.current,
          start: 'top-=300 top+=200',
        },
      })
    }
  }, [])
  return (
    <section className={styles.what} ref={section}>
      <img src="/images/LP/designsystem/what-designsystem-sp.png" alt="背景" className={styles.background_sp} />
      <div className={styles.banner}>
        <div>
          <img src="/images/LP/designsystem/question.svg" alt="" />
          <p className={styles.intro}>INTRODUCTION</p>
          <div className={styles.h2_wrapper}>
            <div className={styles.slider} ref={slide}></div>
            <h2>
              <span>いま、</span>
              <br className={styles.sp} />
              <span>なぜデザインシステムが</span>
              <br />
              <span>必要とされているのか。</span>
            </h2>
          </div>
          <div className={styles.text_wrapper}>
            <p>
              VUCAと言われる社会の中では、変化に素早く対応するスピード、すなわち、利用者により良い体験を素早く提供することが重要です。現在のデジタルプロダクトの世界では、全く新しい物を生み出すよりも、既にあるものを上手く活用して最適化を繰り返すことが重要といえます。そうした状況の中で企業は、複数のプロダクト・複数の部署・複数のデザイナーが一貫性のあるデザインを素早く的確に適用しなければなりません。そうした背景によって今、デザインシステムによる解決が求められています。
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default WhatDesignSystem
